
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'EnvelopeSolid' })
export default class EnvelopeSolid extends Vue {}
